/**
 * Resolved API origin for the current deployment.
 *
 * The bundle is served by the same NestJS process that exposes `/api`, so when
 * VITE_API_URL is unset the origin is the page's own origin — expressed as an
 * empty string so callers produce same-origin relative URLs. Hardcoding
 * `http://localhost:5000` here would make every browser request its own machine
 * and silently break auth, sockets and catalogue data in production.
 */

const raw = (import.meta.env.VITE_API_URL as string | undefined)?.trim() ?? '';

/** Origin only, no trailing slash and without the `/api` suffix. */
export const API_ORIGIN: string = raw.replace(/\/api\/?$/, '').replace(/\/$/, '');

/** Origin + `/api`. */
export const API_BASE: string = `${API_ORIGIN}/api`;

/** Absolute URL for a backend route that lives outside the `/api` prefix. */
export function apiUrl(path: string): string {
  return `${API_ORIGIN}${path}`;
}
